<fui-pill-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()"
                 [ngClass]="'clickable'" [hovered]="hovered">
    <fui-fixtures>
        @if (!disabled) {
            <fui-fixture>
                <fui-mark-toggle [toggled]="popped" (click)="clickToggle($event)">
                    <fui-icon [height]="8" [icon]="'chevron-down'" [width]="10"></fui-icon>
                </fui-mark-toggle>
            </fui-fixture>
        }
        <fui-fixture>
            <fui-pill-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                            [title]="label"></fui-pill-label>
        </fui-fixture>
        <fui-spanning-fixture>
            @if (!disabled || !option || !optionOpenable) {
                <fui-input-dom>
                    <input (blur)="onBlur($event)" #input (focus)="onFocus($event)" [ngModel]="option"
                           (ngModelChange)="modelChanged($event)" [ngClass]="{'direct-input': allowDirectInput}"
                           [placeholder]="placeholder | translate" [readonly]="!allowDirectInput" [tabindex]="tabindex"
                           type="text" [attr.inputMode]="isNumeric ? 'decimal' : 'text'"
                           (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)">
                </fui-input-dom>
            }
            @if (disabled && option && optionOpenable) {
                <span class="select-link" (click)="openOption($event)">{{ option }}</span>
            }
        </fui-spanning-fixture>
        @if (removable) {
            <fui-fixture>
                <fui-mark-button (click)="remove()">
                    <fui-icon [height]="6" [icon]="'close'" [width]="6"></fui-icon>
                </fui-mark-button>
            </fui-fixture>
        }
    </fui-fixtures>
</fui-pill-fascia>
<fui-select-pop [popped]="popped" (popped$)="pop($event)">
    <fui-sections>
        @if (loading) {
            <fui-content-section>
                <fui-loading>
                    <fui-ellipsis-loader></fui-ellipsis-loader>
                </fui-loading>
            </fui-content-section>
        }
        <ng-content select="fui-content-section"></ng-content>
        @if (searchable()) {
            <fui-fab-section>
                <fui-fragments>
                    <fui-fragment>
                        <fui-search-control [label]="'fui.select-control.label.filter' | translate" [(ngModel)]="query"
                                            [placeholder]="'fui.select-control.placeholder.filter' | translate"></fui-search-control>
                    </fui-fragment>
                </fui-fragments>
            </fui-fab-section>
        }
        @if (empty(filteredOptions)) {
            <fui-content-section>
                <fui-empty>
                    <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
                </fui-empty>
            </fui-content-section>
        }
        @if (filled(filteredOptions)) {
            <fui-section>
                <fui-select-options [field]="field" [key]="key" [options]="options" [filteredOptions]="filteredOptions"
                                    id="options"
                                    [optionOpenable]="optionOpenable" (optionOpened$)="optionOpened$.emit($event)"
                                    [allowClearSelectionOption]="allowClearSelectionOption"
                                    [clearSelectionOptionLabel]="clearSelectionOptionLabel"
                                    (selection$)="select($event)"></fui-select-options>
            </fui-section>
        }
        @if (ftb()) {
            <fui-ftb-section>
                <fui-fragments>
                    @if (addable || extendable) {
                        <fui-fragment>
                            <fui-buttons>
                                @if (extendable && options.length > 0) {
                                    <fui-mark-button (click)="extend()"
                                                     [attr.title]="'fui.common.button.search' | translate"
                                                     id="extended-search-button">
                                        <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
                                    </fui-mark-button>
                                }
                                @if (addable) {
                                    <fui-mark-button (click)="add()"
                                                     [attr.title]="'fui.common.button.addNew' | translate"
                                                     id="add-new-button">
                                        <fui-icon [height]="12" [icon]="'plus'" [width]="12"></fui-icon>
                                    </fui-mark-button>
                                }
                                @for (a of actions; track a) {
                                    <fui-action [disabled]="a.disabled" [attr.title]="a.title | translate"
                                                (click)="actionClicked(a)">
                                        <fui-icon [height]="a.iconHeight || 12" [width]="a.iconWidth || 12"
                                                  [icon]="a.icon"></fui-icon>
                                    </fui-action>
                                }
                            </fui-buttons>
                        </fui-fragment>
                    }
                    @if (limited()) {
                        <fui-fragment>
                            <fui-limit-total [limit]="filteredOptions.length" [total]="total"></fui-limit-total>
                        </fui-fragment>
                    }
                </fui-fragments>
            </fui-ftb-section>
        }
    </fui-sections>
</fui-select-pop>
